module.exports = __webpack_public_path__ + "029f91b941fde4861d09d44a6f171e3c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/hootagotchi-s.png
// module id = 2048
// module chunks = 0